const getSiteId = (rootState) => rootState.auth.siteId;

export default getSiteId;
